export function getMobileNumber(state) {
  return state.getIn(["app", "userIdentity", "mobileNumber"]);
}

export function getDeviceToken(state) {
  return state.getIn(["app", "userIdentity", "deviceToken"]);
}

export function getUserIdentityStatus(state) {
  return state.getIn(["app", "userIdentity", "status"]);
}

export function getUserIdentity(state) {
  return state.getIn(["app", "userIdentity"]);
}

export function getUserIdentityAppReferrer(state) {
  return state.getIn(["app", "userIdentity", "appReferrer"]);
}



// WEBPACK FOOTER //
// ./src/state/app/selectors/userIdentity.js